import { useEffect, useState } from 'react';
import 'styles/global.css';
import { Button } from 'react-bootstrap';

/**
 * A multi-level recursive tab selector header
 * @param {{options: object, defaultTab: number[], onChange?: (tabId: string, tabTitle: string), children: (Component | Component[])}}
 * @example
 * const tabOptions = [
 *  {
 *    id: 'tab-1',
 *    title: 'Tab 1',
 *  },
 *  {
 *    title: 'tab-2',
 *    options: [
 *        {
 *          id: 'tab-2-1',
 *          title: 'Tab 2 1',
 *        },
 *        {
 *          id: 'tab-2-2',
 *          title: 'Tab 2 2',
 *        },
 *      ]
 *  }
 * ]
 * return <TabsHeader options={tabOptions} defaultTab={[0]}>
 *  <div id='tab-1'>Tab 1 content</div>
 *  <div id='tab-2-1'>Tab 2 Sub-tab 1 content</div>
 *  <div id='tab-2-2'>Tab 2 Sub-tab 2 content</div>
 * </TabsHeader>
 */
export default function TabsHeader2({
  options,
  depth = 0,
  defaultTab = [0],
  onChange = () => {},
  children,
}) {
  const [selectedTab, _setSelectedTab] = useState(defaultTab[depth] || 0);
  const setSelectedTab = (index) => {
    _setSelectedTab(index);
    onChange(options[index]?.id, options[index]?.title);
  };

  useEffect(() => {
    setSelectedTab(defaultTab[depth] || 0);
  }, [depth]);

  return (
    <div className="d-flex flex-column gap-3 gap-md-0">
      {/* Main Tabs */}
      <div className="d-flex align-items-center flex-column flex-lg-row w-100 bg-primary">
        {options?.map((option, index) => (
          <Button
            className="d-flex align-items-center justify-content-center rounded-0 w-100"
            style={{ height: 31 }}
            onClick={() => setSelectedTab(index)}
            variant="secondary"
          >
            <div
              className="d-flex align-items-center justify-content-center w-100"
              style={{
                height: 27,
                borderBottom: selectedTab === index && '#fff solid 3px',
              }}
            >
              {option.title}
            </div>
          </Button>
        ))}
      </div>

      {/* Sub Tabs */}
      {options[selectedTab]?.options && (
        <TabsHeader2
          options={options[selectedTab].options}
          depth={depth + 1}
          defaultTab={defaultTab}
          onChange={onChange}
        >
          {children}
        </TabsHeader2>
      )}

      {/* Children */}
      <div className="d-flex flex-column h-100">
        {Array.isArray(children)
          ? children.map((child) => {
              if (child.props?.id === (options[selectedTab]?.id || null)) return child;
              else return null;
            })
          : children}
      </div>
    </div>
  );
}
